import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { QueryBuilder } from '@/core/uql';
import cloneDeep from 'lodash/cloneDeep';

interface ShiftCustomPlanState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    prevDocumentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedPlansList: any[];
    prevPlansList: any[];

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
}

const state: ShiftCustomPlanState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    prevDocumentId: null,
    clientId: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedPlansList: [],
    prevPlansList: [],

    targetForDelete: [],
    // products: [],
    remains: []
};

const initState: any = cloneDeep(state);

const PL_RELAED_PRODUCTS_LIST = 'PL_RELAED_PRODUCTS_LIST';
const SHIFT_CUSTOM_LINE_DATA = 'SHIFT_CUSTOM_LINE_DATA';
const WASHIG_SHIFT_LIST = 'WASHIG_SHIFT_LIST';

function getBasketItem(state: ShiftCustomPlanState, saved: any, relTimeOfDay: string) {
  if (saved) {
    return {
      id: saved.id,
      number: saved.number,
      base_name: saved.base_name,
      base_id: saved.base_id,
      starter_type_name: saved.starter_type_name,
      starter_type_id: saved.starter_type_id,
      editable: false,
      attachments: saved.attachments,
      fact_id: saved.fact_id,
      shift_id: saved.shift_id,
      extract_time: saved.extract_time,
      finalized: false,
      recomended_ferment_time: saved.recomended_ferment_time,
      rotate_name: saved.rotate_name,
      logo_name: saved.logo_name,
      activity_name: saved.activity_name,
      logo_id: saved.logo_id,
      activity_id: saved.activity_id,
      dry_causity: saved.dry_causity,
      temp: saved.temp,
      deleted_at: saved.deleted_at,
      line_name: saved.line_name,
      volumes_name: saved.volumes_name,
    };
  } else {
    const letter = relTimeOfDay ? relTimeOfDay[0] : ''
    return {
      id: Math.random(),
      number: (state.relatedPlansList.length + 1) + letter,
      base_name: null,
      base_id: null,
      starter_type_name: null,
      starter_type_id: null,
      editable: true,
      finalized: false,
      attachments: [],
      recomended_ferment_time: null,
      rotate_name: null,
      logo_name: null,
      activity_name: null,
      logo_id: null,
      activity_id: null,
      dry_causity: null,
      temp: null,
      deleted_at: null,
      line_name: null,
      volumes_name: null,
    }
  }

}

export const actions: ActionTree<ShiftCustomPlanState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains, realEndTime, relTimeOfDay }) {
        const vm = (this as any)._vm;
        console.log('relTimeOfDay', relTimeOfDay)

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          commit('START_LOADING');
          console.debug('[ShiftCustomPlan] load finished plans for shift', documentId);
          vm.$db([
            vm.$q(PL_RELAED_PRODUCTS_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'scp.id',
                  full_id: 'sfpc.id',
                  number: 'sfpc.number',
                  product_name: 'p.name',
                  line_name: 'vl.name',
                  equipment_id: 'scp.equipment_id',
                },
                from: 's:shift_full_plan_custom',
                from_as: 'sfpc',
                joins: [
                  {
                    join: 's:shift_custom_plan',
                    type: 'left',
                    as:   'scp',
                    on: {
                      $eq: ['sfpc.plan_id', 'scp.id']
                    }
                  },
                  {
                    join: 's:products',
                    type: 'left',
                    as:   'p',
                    on: {
                      $eq: ['scp.product_id', 'p.id']
                    }
                  },
                  {
                    join: 's:voc_lines',
                    type: 'left',
                    as:   'vl',
                    on: {
                      $eq: ['scp.line_id', 'vl.id']
                    }
                  },
                ],
                order: [
                ],
                page_size: 100,
                where: {
                  $and: [
                    {$eq: [`scp.shift_id`, {$: documentId}]},
                    {$eq: [`scp.kind`, {$: 'finished'}]},
                  ]
                }
              }),
            vm.$q(WASHIG_SHIFT_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sfpc.id',
                  full_id: 'sfpc.id',
                  number: 'sfpc.number',
                  base_name: 'vv.name',
                  line_name: 'vl.name',
                  wash_type: 'vwt.name',
                  water_volume: 'vvw.water_volume',
                  detergent_volume: 'vvw.detergent_volume',
                  detergent_concentration: 'vvw.detergent_concentration',
                  detergent_name: 'vd.name',
                },
                from: 's:shift_full_plan_custom',
                from_as: 'sfpc',
                joins: [
                  {
                    join: 's:shift_plan_washing',
                    as: 'spw',
                    on: {
                      $eq: ['spw.id', 'sfpc.wash_id']
                    }
                  },
                  {
                    join: 's:voc_volumes',
                    as: 'vv',
                    on: {
                      $eq: ['vv.id', 'spw.equipment_id']
                    }
                  },
                  {
                    join: 's:voc_volumes_washings',
                    as: 'vvw',
                    on: {
                      $eq: ['vvw.id', 'spw.washing_id']
                    }
                  },
                  {
                    join: 's:washings',
                    as: 'w',
                    on: {
                      $eq: ['w.id', 'vvw.washing_id']
                    }
                  },
                  {
                    join: 's:voc_washing_types',
                    as: 'vwt',
                    on: {
                      $eq: ['vwt.id', 'w.type_id']
                    }
                  },
                  {
                    join: 's:voc_detergents',
                    as: 'vd',
                    on: {
                      $eq: ['vd.id', 'w.detergent_id']
                    }
                  },
                  {
                    join: 's:voc_lines',
                    type: 'left',
                    as:   'vl',
                    on: {
                      $eq: ['vl.templates', {$: 'wash'}]
                    }
                  },
                ],
                where: {
                  $eq: [`sfpc.shift_id`, {$: documentId}]
                }
              })
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(PL_RELAED_PRODUCTS_LIST);
            const opWashResult = result.getOperation(WASHIG_SHIFT_LIST);
            if (!opRelResult.hasError()) {
              state.relatedPlansList = opRelResult.getContent().documents.map((doc: any) => {
                return doc
              })
              state.relatedPlansList.push(...opWashResult.getContent().documents.map((doc: any) => {
                doc.type = 'wash'
                return doc
              }))
              console.debug('[ShiftCustomPlan] loaded plans',
                'products:', opRelResult.getContent().documents.length,
                'washes:', opWashResult.getContent().documents.length);
            }
            commit('LOADED_SUCCESS');

            resolve(null);
          });
        })
    },


    addItem({ state }, relTimeOfDay) {
      console.log('relTimeOfDay', relTimeOfDay)
      state.relatedPlansList.push(
        getBasketItem(state, null, relTimeOfDay)
      )
    },

    removeItem({ state }, index: number) {
        if (state.relatedPlansList[index].id) {
            state.targetForDelete.push(state.relatedPlansList[index].id)
        }

        state.relatedPlansList.splice(index, 1);
    },

    changeFormValue({ state, commit }, { index, field, newValue}) {
      commit('SET_FROM_DATA', {index, field, newValue})
    },

    saveForm({ state, dispatch }, {realEndTime}) {
      const vm = (this as any)._vm;
      const allowedFields = ['id', 'base_id', 'number', 'attachments', 'starter_type_id'];

      return new Promise((resolve, reject) => {
        const normalizedItemsData = state.relatedPlansList.map((item, index) => {
          console.log('n => ', item);
          const cleanDocuemnt: any = Object.keys(item)
          .filter((key: string) => allowedFields.includes(key))
          .reduce((obj: any, key: string) => {
              console.log('key => ', key, obj);
              if (key == 'id') {
                console.log('d1 => ', item[key]);
                item[key] = (typeof(item[key]) == 'string') ? item[key] : null;
                console.log('d2 => ', item[key]);
              }
              obj[key] = item[key];
              return obj;
            }, {});

          console.log('d => ', cleanDocuemnt);
          return cleanDocuemnt;
        });

        const queries = [
          vm.$q(`SAVE_DEAL_BASKET`)
            .update(state.documentId, {})
            .createManyRelation('shift_plan_vdp', 'shift_id', (createRelated: any) => {
              return normalizedItemsData.filter((item: any) => !item.id || (typeof(item.id) !== 'string')).map((item, index) => createRelated(item));
            })
            .updateManyRelation('shift_plan_vdp', 'shift_id', (updateRelated: any) => {
              return normalizedItemsData.filter((item: any) => (typeof(item.id) == 'string')).map((item, index) => updateRelated(item))
            })
        ]

        vm.$db(queries)
          .then((result: ServerResult) => {
            const totalSaveRes = !result.getOperation(`SAVE_DEAL_BASKET`).hasError();
            if (totalSaveRes) {
              state.targetForDelete = [];

              dispatch('loadData', { documentId: state.documentId, realEndTime})
                .then(() => {
                  resolve();
                })
            } else {
              reject();
            }
          });
      })
    },

    addAttachments({state, dispatch}, {newValue, row, realEndTime}) {
      const index = state.relatedPlansList.indexOf(row)
      state.relatedPlansList[index].attachments = [
        newValue,
        ...(state.relatedPlansList[index].attachments ? state.relatedPlansList[index].attachments : []),
      ]
      dispatch('saveForm', {realEndTime})
    },

    setExctartTime({ state, dispatch }, {row, documentId, extract_time}) {
      console.log(row, documentId, extract_time)
      const vm = (this as any)._vm;
      extract_time = extract_time ? extract_time : row.extract_time;

      vm.$db([
          (vm.$q('SET_EXTRACT_TIME') as QueryBuilder)
            .update(row.fact_id, { extract_time: moment(extract_time).utc().local().format() })
      ])
      .then(() => {
          dispatch('loadData', { documentId: state.documentId, silence: true})
      })
    },

    deleteDocument({ state, dispatch }, row) {
      const vm = (this as any)._vm;

      vm.$db([
          (vm.$q('DELETE_DOCUMENT') as QueryBuilder)
            .update(row.id, { deleted_at: moment().utc().local().format() })
      ])
      .then(() => {
          dispatch('loadData', { documentId: state.documentId, silence: true})
      })
    },

    restoreDocument({ state, dispatch }, row) {
      const vm = (this as any)._vm;

      vm.$db([
          (vm.$q('DELETE_DOCUMENT') as QueryBuilder)
            .update(row.id, { deleted_at: null })
      ])
      .then(() => {
          dispatch('loadData', { documentId: state.documentId, silence: true})
      })
    },
};

export const mutations: MutationTree<ShiftCustomPlanState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_FROM_DATA(state, {index, field, newValue}) {
    console.log('------>', index, field, newValue)
    const _idx = state.relatedPlansList.indexOf(index)
    state.relatedPlansList[_idx][field] = newValue;
  }

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftCustomPlanState, RootState> = {
  totals : (state: ShiftCustomPlanState) => {
    return {
      sum: state.relatedPlansList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
};

export const STORE_KEY = '$_shift_custom_plan_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
